import { PlaceholdersId, TFComponent } from '@types';

import { AccessDeniedPlaceholder } from './accessDenied';

export const accessDenied: TFComponent = {
	component: AccessDeniedPlaceholder,
	id: PlaceholdersId.accessDenied,
	name: 'accessDenied',
};
